module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/transform.js
// module id = 149
// module chunks = 0 1